import React, { useEffect, useState } from 'react';
import { Row } from 'reactstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

function DashboardGoogleMaps({ markers, apiKey, loading }) {
  const [map, setMap] = useState(null);

  useEffect(() => {
    if (!loading) {
      const initMap = () => {
        const mapInstance = new window.google.maps.Map(
          document.getElementById('map'),
          {
            center: { lat: -9.488492814857791, lng: -53.919392560480865 },
            zoom: 4,
          }
        );

        setMap(mapInstance);
      };

      if (!window.google) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
        script.defer = true;
        script.async = true;
        window.initMap = initMap;
        document.head.appendChild(script);
      } else {
        initMap();
      }
    }
  }, [apiKey, markers, loading]);

  useEffect(() => {
    if (map && markers) {
      markers.forEach((marker) => {
        const { lat, lng, total, size } = marker;

        const customMarker = new window.google.maps.OverlayView();

        customMarker.latlng = new window.google.maps.LatLng(lat, lng);
        customMarker.args = { total, size };
        customMarker.setMap(map);

        customMarker.draw = function () {
          const self = this;
          let div = this.div;

          if (!div) {
            div = this.div = document.createElement('div');

            div.className =
              'marker rounded-circle font-weight-bold d-flex align-items-center justify-content-center text-white';

            div.style.position = 'absolute';
            div.style.cursor = 'pointer';
            div.style.width = self.args.size;
            div.style.height = self.args.size;
            div.style.fontSize = '16px';
            div.style.border = '4px white solid';
            div.style.background = '#283593';

            div.innerHTML = self.args.total;

            div.addEventListener('click', function (event) {
              window.google.maps.event.trigger(self, 'click');
            });

            const panes = this.getPanes();
            panes.overlayImage.appendChild(div);
          }

          const point = this.getProjection().fromLatLngToDivPixel(this.latlng);

          if (point) {
            div.style.left = point.x + 'px';
            div.style.top = point.y + 'px';
          }
        };

        customMarker.remove = function () {
          if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
          }
        };

        customMarker.getPosition = function () {
          return this.latlng;
        };
      });
    }
  }, [map, markers]);

  return (
    <>
      {loading ? (
        <SkeletonTheme baseColor="#8B919F">
          <Row className="p-1">
            <div className="text-center">
              <Skeleton height={800} />
            </div>
          </Row>
        </SkeletonTheme>
      ) : (
        <div id="map" style={{ height: '800px' }}></div>
      )}
    </>
  );
}

export default DashboardGoogleMaps;
